module.exports = __webpack_public_path__ + "static/media/7.8371d254.jpg";